import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { Form, Input, Divider } from 'antd'
import { Link, Redirect } from 'react-router-dom'
import { compose } from 'redux'
import { trim, isEmpty } from 'lodash'
import { withNamespaces } from '@edulastic/localization'
import { connect } from 'react-redux'
import { withWindowSizes, notification, FlexContainer } from '@edulastic/common'
import { IconLock, IconHash, IconUser, IconMail } from '@edulastic/icons'
import { placeholderPrefixColor } from '@edulastic/colors'
import { MAX_TAB_WIDTH } from '../../../author/src/constants/others'

import {
  RegistrationWrapper,
  RegistrationHeader,
  LinkDiv,
  ThirdPartyLoginBtn,
  FormBody,
  RegisterButton,
  RightContainer,
  SignUpContainer,
  SignUpHeader,
  StyledButtonText,
  CreateAccountDivider,
  BoldText,
  ClassCodeHeading,
} from '../styled'
import {
  signupAction,
  googleLoginAction,
  msoLoginAction,
  studentSignupCheckClasscodeAction,
  getTooManyAtempt,
  setTooManyAttemptAction,
} from '../../Login/ducks'
import {
  getPartnerKeyFromUrl,
  validatePartnerUrl,
  getPartnerLoginUrl,
  getPartnerTeacherSignupUrl,
  getPartnerDASignupUrl,
  getDistrictLoginUrl,
  getDistrictTeacherSignupUrl,
  isDistrictPolicyAllowed,
  isEmailValid,
  updateMetaTag,
  removeMetaTag,
} from '../../../common/utils/helpers'
import { Partners } from '../../../common/utils/static/partnerData'

import googleIcon from '../../assets/google-btn.svg'
import icon365 from '../../assets/icons8-office-365.svg'
import PasswordPopup from './PasswordPopup'
import { LeftContainer } from './LeftContainer'
import { ForgotPasswordPopup } from '../../Login/components/forgotPasswordPopup'

const FormItem = Form.Item
const GOOGLE = 'google'
const OFFICE = 'office'
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
  },
}
class StudentSignup extends React.Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    signup: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  }

  state = {
    confirmDirty: false,
    method: '',
    signupError: {},
    showModal: false,
    proceedBtnDisabled: true,
    submitting: false,
  }

  componentDidMount() {
    updateMetaTag({ content: 'Pear Assessment for Students' })
  }

  componentWillUnmount() {
    removeMetaTag() // Removing description meta tag
  }

  closeModal = () => {
    this.setState({
      showModal: false,
    })
  }

  handleSubmit = (e) => {
    const { form, signup, t, districtPolicy } = this.props
    const { method, password: passwordForExistingUser } = this.state
    e && e.preventDefault()
    form.validateFieldsAndScroll(
      (err, { password, email, name, classCode }) => {
        if (!err) {
          if (method === GOOGLE) {
            const { googleLoginAction } = this.props
            googleLoginAction({ role: 'student', classCode })
          } else if (method === OFFICE) {
            const { msoLoginAction } = this.props
            msoLoginAction({ role: 'student', classCode })
          } else {
            this.setState({ submitting: true })
            signup({
              passwordForExistingUser,
              password,
              email,
              name,
              role: 'student',
              classCode,
              policyViolation: t('common.policyviolation'),
              districtId: districtPolicy ? districtPolicy.orgId : undefined,
              errorCallback: this.errorCallback,
            })
          }
        }
      }
    )
  }

  handleConfirmBlur = ({ target: { value } }) => {
    let { confirmDirty } = this.state
    confirmDirty = confirmDirty || !!value
    this.setState({ confirmDirty })
  }

  signupMethod = (key) => () => {
    this.setState({
      method: key,
    })
  }

  onChangeEmail = () => {
    this.setState((state) => ({
      ...state,
      signupError: {
        ...state.signupError,
        usernameOrEmail: '',
      },
    }))
  }

  onChangeClassCode = () => {
    this.setState((state) => ({
      ...state,
      signupError: {
        ...state.signupError,
        classCode: '',
      },
    }))
  }

  onBlurClassCode = (event) => {
    const { studentSignupCheckClasscodeAction, districtPolicy } = this.props
    if (event.currentTarget.value) {
      studentSignupCheckClasscodeAction({
        reqData: {
          classCode: event.currentTarget.value,
          role: 'student',
          signOnMethod: 'userNameAndPassword',
          districtId: districtPolicy ? districtPolicy.orgId : undefined,
        },
        errorCallback: this.errorCallback,
      })
    }
  }

  errorCallback = (error) => {
    if (
      error === 'Username/Email already exists. Please sign in to your account.'
    ) {
      this.setState((state) => ({
        ...state,
        signupError: {
          ...state.signupError,
          usernameOrEmail: 'error',
        },
      }))
    } else if (error === 'Please provide a valid class code.') {
      this.setState((state) => ({
        ...state,
        signupError: {
          ...state.signupError,
          classCode: 'Please provide a valid class code.',
        },
      }))
    } else if ((error || {}).askPassword) {
      if (error.passwordMatch === false) {
        notification({ messageKey: 'passwordIsIncorrect' })
      }
      this.setState({
        showModal: true,
        existingUser: error,
      })
    } else if (error === 'too_many_attempts') {
      this.setState({
        showModal: false,
      })
    } else {
      notification({ msg: error })
    }
    this.setState({ submitting: false })
  }

  onPasswordChange = (password) => {
    this.setState({
      proceedBtnDisabled: isEmpty(password),
      password,
    })
  }

  onClickProceed = () => {
    this.handleSubmit()
  }

  renderGeneralFormFields = () => {
    const {
      form: { getFieldDecorator, getFieldError },
      t,
      isSignupUsingDaURL,
      orgShortName,
      orgType,
    } = this.props

    const partnerKey = getPartnerKeyFromUrl(location.pathname)
    const partner = Partners[partnerKey]

    const classCodeError =
      this.state.signupError.classCode || getFieldError('classCode')
    const usernameEmailError =
      (this.state.signupError.usernameOrEmail && (
        <span>
          Username/Email already exists. Please{' '}
          <Link
            to={
              isSignupUsingDaURL
                ? getDistrictLoginUrl(orgShortName, orgType)
                : getPartnerLoginUrl(partner)
            }
          >
            sign in
          </Link>{' '}
          to your account.
        </span>
      )) ||
      getFieldError('email')

    return (
      <>
        <FormItem
          {...formItemLayout}
          validateStatus={classCodeError ? 'error' : 'success'}
          help={classCodeError}
        >
          {getFieldDecorator('classCode', {
            validateFirst: true,
            initialValue: '',
            rules: [
              {
                required: true,
                message: t('component.signup.student.validclasscode'),
              },
            ],
          })(
            <Input
              prefix={<IconHash color={placeholderPrefixColor} />}
              data-cy="classCode"
              placeholder="Class Code"
              onChange={this.onChangeClassCode}
              onBlur={this.onBlurClassCode}
              aria-label="Class Code"
            />
          )}
        </FormItem>
        <FormItem {...formItemLayout}>
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: t('component.signup.student.validinputname'),
              },
            ],
          })(
            <Input
              data-cy="name"
              prefix={<IconUser color={placeholderPrefixColor} />}
              placeholder="Student Name"
              aria-label="Student Name"
            />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          validateStatus={usernameEmailError ? 'error' : 'success'}
          help={usernameEmailError}
        >
          {getFieldDecorator('email', {
            validateFirst: true,
            initialValue: '',
            rules: [
              {
                transform: (value) => trim(value),
              },
              {
                required: true,
                message: t('common.validation.emptyemailid'),
              },
              {
                type: 'string',
                message: t('common.validation.validemail'),
              },
              {
                validator: (rule, value, callback) =>
                  isEmailValid(
                    rule,
                    value,
                    callback,
                    'both',
                    t('common.validation.validemail')
                  ),
              },
            ],
          })(
            <Input
              data-cy="email"
              prefix={<IconMail color={placeholderPrefixColor} />}
              placeholder="Student Email"
              onChange={this.onChangeEmail}
              aria-label="Student Email"
            />
          )}
        </FormItem>
        <FormItem {...formItemLayout}>
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: t('common.validation.emptypassword'),
              },
            ],
          })(
            <Input
              data-cy="password"
              prefix={<IconLock color={placeholderPrefixColor} />}
              type="password"
              autoComplete="off"
              placeholder="Password"
              aria-label="Password"
            />
          )}
        </FormItem>
      </>
    )
  }

  renderFormHeader = () => {
    const { isSignupUsingDaURL, districtPolicy, t } = this.props
    return (
      <>
        <SignUpHeader>Sign up As Student</SignUpHeader>
        {isDistrictPolicyAllowed(
          isSignupUsingDaURL,
          districtPolicy,
          'googleSignOn'
        ) || !isSignupUsingDaURL ? (
          <ThirdPartyLoginBtn
            onClick={this.signupMethod(GOOGLE)}
            span={20}
            offset={2}
          >
            <img src={googleIcon} alt="Google" />{' '}
            <StyledButtonText>
              {t('component.signup.googlesignupbtn')}
            </StyledButtonText>
          </ThirdPartyLoginBtn>
        ) : null}
        {isDistrictPolicyAllowed(
          isSignupUsingDaURL,
          districtPolicy,
          'office365SignOn'
        ) || !isSignupUsingDaURL ? (
          <ThirdPartyLoginBtn
            onClick={this.signupMethod(OFFICE)}
            span={20}
            offset={2}
          >
            <img src={icon365} alt="Office 365" />{' '}
            <StyledButtonText>
              {t('component.signup.office365signupbtn')}
            </StyledButtonText>
          </ThirdPartyLoginBtn>
        ) : null}
      </>
    )
  }

  renderGoogleORMSOForm = () => {
    const {
      form: { getFieldDecorator, getFieldError },
      t,
    } = this.props

    const classCodeError =
      this.state.signupError.classCode || getFieldError('classCode')

    return (
      <FormItem
        {...formItemLayout}
        validateStatus={classCodeError ? 'error' : 'success'}
        help={classCodeError}
      >
        {getFieldDecorator('classCode', {
          rules: [
            {
              required: true,
              message: t('component.signup.student.validclasscode'),
            },
          ],
        })(
          <Input
            prefix={<IconHash color={placeholderPrefixColor} />}
            data-cy="classCode"
            aria-label="Class Code"
            placeholder="Class Code"
            onChange={this.onChangeClassCode}
            onBlur={this.onBlurClassCode}
          />
        )}{' '}
      </FormItem>
    )
  }

  render() {
    const {
      t,
      isSignupUsingDaURL,
      districtPolicy,
      orgShortName,
      orgType,
      generalSettings,
      windowWidth,
      tooManyAttempt = false,
      setTooManyAttempt = () => {},
    } = this.props

    const { method, submitting } = this.state
    const partnerKey = getPartnerKeyFromUrl(location.pathname)
    const partner = Partners[partnerKey]

    const isUserNameAndPasswordAllowed =
      (isDistrictPolicyAllowed(
        isSignupUsingDaURL,
        districtPolicy,
        'userNameAndPassword'
      ) ||
        !isSignupUsingDaURL) &&
      method !== GOOGLE &&
      method !== OFFICE
    const isDistrictSignup =
      generalSettings?.pageBackground && isSignupUsingDaURL
    return (
      <div>
        <PasswordPopup
          showModal={this.state.showModal}
          existingUser={this.state.existingUser}
          disabled={this.state.proceedBtnDisabled}
          closeModal={() => this.setState({ showModal: false })}
          onChange={this.onPasswordChange}
          onClickProceed={this.onClickProceed}
        />
        {tooManyAttempt && (
          <ForgotPasswordPopup
            visible={tooManyAttempt}
            onCancel={() => setTooManyAttempt(false)}
            onOk={() => setTooManyAttempt(false)}
          />
        )}
        {!isSignupUsingDaURL && !validatePartnerUrl(partner) ? (
          <Redirect exact to="/" />
        ) : null}
        <RegistrationWrapper
          image={
            isDistrictSignup
              ? generalSettings.pageBackground
              : partner.background
          }
        >
          {windowWidth > MAX_TAB_WIDTH && (
            <LeftContainer
              currentPage="studentsignup"
              isDistrictSignup={isDistrictSignup}
            />
          )}
          <RightContainer windowWidth={windowWidth}>
            <Helmet>
              <link
                rel="canonical"
                href="https://assessment.peardeck.com/studentsignup"
              />
            </Helmet>
            <RegistrationHeader type="flex" align="middle">
              <span>{t('component.signup.alreadyhaveanaccount')}</span>
              <Link
                to={
                  isSignupUsingDaURL
                    ? getDistrictLoginUrl(orgShortName, orgType)
                    : getPartnerLoginUrl(partner)
                }
              >
                Sign In
              </Link>
            </RegistrationHeader>
            <SignUpContainer isDistrictSignup={isDistrictSignup}>
              {method !== GOOGLE &&
                method !== OFFICE &&
                this.renderFormHeader()}
              {isUserNameAndPasswordAllowed ? (
                <CreateAccountDivider>
                  {t('component.signup.formboxheading')}
                </CreateAccountDivider>
              ) : null}
              {(method === GOOGLE || method === OFFICE) && (
                <ClassCodeHeading>
                  Please enter your Class Code
                </ClassCodeHeading>
              )}

              <FormBody>
                <Form onSubmit={this.handleSubmit}>
                  {isUserNameAndPasswordAllowed
                    ? this.renderGeneralFormFields()
                    : null}
                  {(method === GOOGLE || method === OFFICE) &&
                    this.renderGoogleORMSOForm()}
                  <FormItem>
                    {isUserNameAndPasswordAllowed ? (
                      <RegisterButton
                        data-cy="signup"
                        type="primary"
                        htmlType="submit"
                        disabled={submitting}
                      >
                        {t('component.signup.student.signupstudentbtn')}
                      </RegisterButton>
                    ) : null}
                    {(method === GOOGLE || method === OFFICE) && (
                      <RegisterButton
                        data-cy="signup"
                        type="primary"
                        htmlType="submit"
                        disabled={submitting}
                        $mt="18px"
                      >
                        {t('component.signup.student.signupentercode')}
                      </RegisterButton>
                    )}
                  </FormItem>
                </Form>
              </FormBody>
              <Divider />
              <FlexContainer
                width="100%"
                style={{ gap: '20px' }}
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <BoldText>Not a student?</BoldText>
                <div>
                  {isDistrictPolicyAllowed(
                    isSignupUsingDaURL,
                    districtPolicy,
                    'teacherSignUp'
                  ) || !isSignupUsingDaURL ? (
                    <LinkDiv>
                      <Link
                        to={
                          isSignupUsingDaURL
                            ? getDistrictTeacherSignupUrl(orgShortName, orgType)
                            : getPartnerTeacherSignupUrl(partner)
                        }
                      >
                        {t('component.signup.signupasteacher')}
                      </Link>
                    </LinkDiv>
                  ) : null}

                  {!isSignupUsingDaURL ? (
                    <LinkDiv>
                      <Link to={getPartnerDASignupUrl(partner)}>
                        {t('component.signup.signupasadmin')}
                      </Link>
                    </LinkDiv>
                  ) : null}
                </div>
              </FlexContainer>
            </SignUpContainer>
          </RightContainer>
        </RegistrationWrapper>
      </div>
    )
  }
}

const SignupForm = Form.create()(StudentSignup)

const enhance = compose(
  withNamespaces('login'),
  withWindowSizes,
  connect(
    (state) => ({
      tooManyAttempt: getTooManyAtempt(state),
    }),
    {
      signup: signupAction,
      googleLoginAction,
      msoLoginAction,
      studentSignupCheckClasscodeAction,
      setTooManyAttempt: setTooManyAttemptAction,
    }
  )
)

export default enhance(SignupForm)
